<template>
    <div class="" :id="this.$route.name">
        <Card add back tools toolsColumns>
            <template v-slot:header>
                <h4 class="d-inline">لیستـ  ـسازمان ها</h4>
                <hr>    
            </template>
            <template v-slot:content>
                 <grid  :IsInformation="false"></grid>
            </template>
        </Card>
    </div>
</template>
<script>
import Card from '@/components/Card/Card.vue';
import Grid from '../Public/Grid.vue';
export default {
    data(){
        return{

        }
    },
    components: {
        Card,Grid
    },
}
</script>
<style scoped>
/* hr{
    background:var(--sidebar-color-item) !important;
} */
</style>